import React from 'react';
import { PortalWithState } from 'react-portal';
import styled from 'styled-components';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faBuilding from '@fortawesome/fontawesome-pro-light/faBuilding';
import faArrowLeft from '@fortawesome/fontawesome-pro-light/faArrowLeft';
import Tooltip from 'rc-tooltip';
import SearchModal from './SearchModal';

const CustomPortal = styled.div`
  background-color: #fff;
  border-right: grey solid 1px;
  :focus {
    outline: none;
  }
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: 400px;
  z-index: 1071;
  padding: 10px;
  overflow-y: auto;
`;

class SwitchProjectsIcon extends React.Component {
  render() {
    return (
      <PortalWithState closeOnOutsideClick closeOnEsc>
        {({ openPortal, closePortal, isOpen, portal }) => (
          <React.Fragment>
            <Tooltip
              placement="right"
              overlay={'Switch Projects'}
              // onVisibleChange={this.handleVisibleChange}
              // visible={tooltipIsVisible}
            >
              <FontAwesomeIcon
                className="fa-style"
                size="lg"
                icon={faBuilding}
                onClick={openPortal}
                style={{ cursor: 'pointer' }}
              />
            </Tooltip>
            {portal(
              <CustomPortal>
                <FontAwesomeIcon
                  className="fa-style"
                  size="lg"
                  icon={faArrowLeft}
                  onClick={closePortal}
                  style={{ cursor: 'pointer', marginBottom: 10 }}
                />
                <SearchModal closePortal={closePortal} />
              </CustomPortal>,
            )}
          </React.Fragment>
        )}
      </PortalWithState>
    );
  }
}

export default SwitchProjectsIcon;



// WEBPACK FOOTER //
// ./src/components/toolbars/IconNavList/industry/construction/SwitchProjectsIcon/SwitchProjectIcon.js